// require('./vendor'); // vem do webkit

import LocomotiveScroll from 'locomotive-scroll';
const locomotiveScroll = new LocomotiveScroll({
    lenisOptions: {
        wrapper: window,
        content: document.documentElement,
        lerp: 0.1,
        duration: 1.2,
        orientation: 'vertical',
        gestureOrientation: 'vertical',
		smooth: true,
        smoothMobile: true,
        smoothWheel: true,
        smoothTouch: false,
        wheelMultiplier: 1,
        touchMultiplier: 2,
        normalizeWheel: true,
        smoothTouch : true,
        smartphone: {
            smooth: true,
        },
        mobile: {
            breakpoint: 768,
            smooth: true,
            getDirection: true,
        },
        tablet: {
            breakpoint: 1000,
            smooth: true,
            getDirection: true,
        },
        easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), // https://www.desmos.com/calculator/brs54l4xou
    },
});


require('../../node_modules/jquery-validation/dist/jquery.validate');
require('/node_modules/simplelightbox/dist/simple-lightbox.min.js');

window.$ = window.jQuery    = require('jquery');

//-> Lib GSAP
import { gsap }                 from "gsap";
import { PixiPlugin }           from "gsap/PixiPlugin.js";
import { MotionPathPlugin }     from "gsap/MotionPathPlugin.js";
import { ScrollTrigger }        from "gsap/ScrollTrigger";
import { ScrollToPlugin }       from "gsap/ScrollToPlugin";
gsap.registerPlugin(PixiPlugin, MotionPathPlugin, ScrollTrigger, ScrollToPlugin); 

import Svg          			    from "./components/Svg";
import * as mask                    from "./components/inputMask";
// import windowScrollPage             from "./components/windowScrollPage";
import controlVideos                from "./components/ControlVideos";
import ContentDinamic               from "./components/ContentDinamic";
import * as bootstrap               from 'bootstrap'
import LoadPage              	    from "./components/AjaxLoadPage";
import * as SimpleLightbox          from "./components/SimpleLightBox";
import * as FormAjax 			    from "./components/FormAjax";
import * as jqValidate          from "./components/JqValidate";

import * as ModalVideo              from "./components/ModalVideo";
import ModalWhats from './components/ModalWhats';
// import Swiper                       from "./components/SwiperGallery";
// import 'slick-carousel';
// import * as gallery             from "./components/slick-carrossel";

$(function(){
    Svg.init();
})

window.addEventListener('load', function(){
	render();
});

const render = () => {

    LoadPage.init();
	mask.jqMAsk();
    SimpleLightbox.init();
    ModalVideo.init();
    controlVideos.playVideo();
    ContentDinamic.linkDinamic();
    ModalWhats.init();
    FormAjax.init();
	jqValidate.default();
	// windowScrollPage.init();
	// Swiper.init();
}